import { render, staticRenderFns } from "./CourseSelection.vue?vue&type=template&id=439e9dfc&"
import script from "./CourseSelection.vue?vue&type=script&lang=js&"
export * from "./CourseSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports